<template>
	<div class="right_body">
  <list-btn
  :listArr="listArr"
  :sdata="sdata"
  ></list-btn>
  <search-box :fromData="fromData" @subSearch="subSearch"></search-box>
  <el-table
   :data="listArr"
   style="width: 100%;margin-bottom: 20px;"
   row-key="resourceId"
   border
   highlight-current-row
   @current-change="handleCurrentChange"
   :tree-props="{children: 'children', hasChildren: 'hasChildren'}">
   <el-table-column
     type="index"
     label="序号"
     width="50">
   </el-table-column>
   <el-table-column
     v-for="(item,index) in tabColumns"
     :prop="item.field"
     :label="item.title"
     :formatter="item.formatter"
     :width="item.width">
   </el-table-column>
 </el-table>

  <!-- 新增 -->
  <!-- <el-dialog :title="dialogTitle" :visible.sync="dialogFormVisible" customClass="customWidth" v-dialogDrag>
    <el-form :model="resourceFrom" :rules="rules" ref="resourceFrom" label-width="100px" class="dialog-from flex">
      <el-form-item class="item" label="资源类型" prop="resourceType">
        <el-select v-model="resourceTypeTxt" placeholder="请选择" @change="changeType">
          <el-option
          v-for="(item,index) in resourceType"
          :key="index"
          :label="item.label" :value="item.value"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item class="item" label="父级资源" prop="parentResourceId">
        <el-select v-model="parentResourceTxt" placeholder="请选择" @change="changeParent">
          <el-option label="顶级" value="0"></el-option>
          <template v-for="(item,index) in listArr" v-if="item.resourceId != sdata.resourceId">
            <el-option :label="item.value" :value="item.resourceId"></el-option>
            <template v-if="item.children" v-for="(vitem,vindex) in item.children">
              <el-option :label="vitem.value" :value="vitem.resourceId"></el-option>
            </template>
          </template>
        </el-select>
      </el-form-item>
      <el-form-item class="item" label="路由Name" prop="resourceCode">
        <el-input v-model="resourceFrom.resourceCode" autocomplete="off" placeholder="用于路由"></el-input>
      </el-form-item>
      <el-form-item class="item" label="资源名称" prop="resourceName">
        <el-input v-model="resourceFrom.resourceName" autocomplete="off" placeholder="用于显示"></el-input>
      </el-form-item>
      <el-form-item class="item" label="资源URL" prop="resourceHref">
        <el-input v-model="resourceFrom.resourceHref" autocomplete="off" placeholder="连接地址"></el-input>
      </el-form-item>
      <el-form-item class="item" label="资源排序" prop="flag">
        <el-input v-model="resourceFrom.sort" autocomplete="off" placeholder="" oninput="value=value.replace('/[\d]/g','')"></el-input>
      </el-form-item>
      <el-form-item class="item" label="备注" prop="remarks">
        <el-input v-model="resourceFrom.remarks" autocomplete="off"></el-input>
      </el-form-item>
      <el-form-item class="item" label="资源状态" prop="resourceStatus">
        <el-select v-model="resourceStatusTxt" placeholder="资源状态">
          <el-option label="启用" value="1"></el-option>
          <el-option label="冻结" value="0"></el-option>
        </el-select>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button @click="dialogFormVisible = false">取 消</el-button>
      <el-button type="primary" @click.stop="submitForm" v-loading="$store.state.isLoading">确 定</el-button>
    </div>
  </el-dialog> -->

	</div>
</template>

<script>
import {resource} from 'api/auth.js'

import listBtn from 'components/btn/listBtn.vue';
import tabList from 'components/table/listRadio.vue';
import searchBox from './components/search.vue';

 
export default{
	components:{listBtn,tabList,searchBox},
	data() {
		return {
      isComponentChild:false,
      isDelList:false,//是否显示已删除的
			sdata:{},
			slist:[],//未变成树型数组
			listArr:[],
			isEdit:false,//状态
      dialogTitle:"",
      resourceTypeTxt:"",//资源类型
      parentResourceTxt:"顶级",
      resourceStatusTxt:"启用",
      resourceFrom:{
        "resourceType":1,
        "resourceStatus":1
      },//提交信息
      rules:{
        type: [{
          required: true,
          message: '请选择类型',
          trigger: 'change',
        }],
        resourceCode:[{
          required: true,
          message: '请输入路由Name',
          trigger: 'blur',
        }],
        resourceHref:[{
          required: true,
          message: "请输入资源URL",
          trigger: "blur" ,
        }],
        resourceName:[{
          required: true,
          pattern:/^[a-zA-Z0-9_\u4E00-\u9FA5]+$/,
          message: "请输入资源名称",
          trigger: "blur" ,
        }]
      },
      dialogFormVisible:false,
      resourceType:[
        {"label":"主模块","value":1},
        {"label":"子模块","value":2},
        {"label":"菜单","value":3},
        {"label":"功能","value":4},
      ],
      tabColumns:[
        {field: 'resourceName', title: '资源名称',"sortable":true},
        {field:"sort",title:"资源排序",width:100},
        // {field: 'resourceHref', title: '资源URL'},
        {field: 'resourceCode', title: '路由Name'},
        {field: 'type', title: '资源类型',
        formatter(row){
          return row.resourceType == 1 ? "主模块" : row.resourceType == 2 ? "子模块" : row.resourceType == 3 ? "菜单" : "功能";
        }}
      ],//表头字段
			total:0,//总条数
			pages:0,//总页数
			fromData:{
				page:1,//当前页
				pageSize:100,//每页显示的数量,
				searchCriteria:{//查询的附加条件
				}
			}
		}
	},
	created(){
		this.getListArr();
	},
  updated:function(){

  },
	methods:{
    //递归成树状
    filterArray(data, parent,level = 0){
      level++;
      var tree = [];
      var temp;
      for (var i = 0; i < data.length; i++) {
        if (data[i].parentResourceId == parent) {
          let levelStr = "";
          for(var j=1;j<level;j++){
            levelStr = levelStr + '|- ';
          }
          data[i].level = level;
          data[i].value = levelStr + data[i].resourceName;
          var obj = data[i];
          temp = this.filterArray(data, data[i].resourceId,level);
          if (temp.length > 0) {
            obj.children = temp;
          }
          tree.push(obj);
        }
      }
      return tree;
    },
		// showErrorMsg(txt){
		// 	this.$message.error(txt);
		// },
    //单击选中这条数据
    handleCurrentChange(val) {
      // this.sdata = val;
      console.log(this.sdata);
    },
    // changeType(val){
    //   console.log(val,11);
    //   this.resourceFrom.resourceType = val;
    // },
    //改变父级ID
    // changeParent(val){
    //   this.resourceFrom.parentResourceId = val;
    // },
    //获取列表 
    async getListArr(){
      let res = await this.$post(resource.list,this.fromData);
      if(res.status && res.data.list){
        console.log(res.data,"=========获取列表数据")
        this.slist = res.data.list;
        this.listArr = this.filterArray(res.data.list,0);
      }else{
        this.listArr = [];
      }
      // console.log(this.listArr,888);
    },
    //搜索
    subSearch(){
      this.getListArr();
    },
		//新增
		// add(){
    //   this.dialogTitle = "资源添加";
    //   this.isEdit = false;
    //   this.dialogFormVisible = true;
    //   this.resourceFrom = {
    //     resourceType:1,
    //     parentResourceId:0
    //   };
    //   this.resourceTypeTxt = "";
    //   if(this.sdata.resourceId){
    //     if(this.sdata.resourceId != 4){
    //       this.resourceFrom.parentResourceId = this.sdata.resourceId;
    //       this.parentResourceTxt = this.sdata.resourceName;
    //     }
    //   }
		// },
		//编辑
		// edit(){
    //   this.dialogTitle = "资源编辑";
    //   this.isEdit = true;
		// 	if(!this.sdata.resourceId){
		// 		this.$message.error('请选择要编辑的');
		// 		return;
		// 	}
    //   let obj = this.slist.find(v=>v.resourceId === this.sdata.parentResourceId);
    //   if(obj){
    //     this.parentResourceTxt = obj.value;
    //     this.resourceFrom.parentResourceId = obj.resourceId;
    //   }else{
    //     this.parentResourceTxt = "顶级";
    //     this.resourceFrom.parentResourceId = 0;
    //   }
    //   let typeObj = this.resourceType.find(v=>v.value == this.sdata.resourceType);
    //   if(typeObj){
    //     this.resourceTypeTxt = typeObj.label;
    //     this.resourceFrom.resourceType = typeObj.value;
    //   }else{
    //     this.resourceTypeTxt = "";
    //     this.resourceFrom.resourceType = 0;
    //   }
    //   this.dialogFormVisible = true;
    //   this.resourceFrom = JSON.parse(JSON.stringify(this.sdata));
		// },
		//删除
		// del(){
		// 	if(!this.sdata.resourceId){
		// 		this.$message.error('请选择要删除的工厂');
		// 		return;
		// 	};
		// 	this.$confirm('确定删除么, 是否继续?', '提示', {
		// 		confirmButtonText: '确定',
		// 		cancelButtonText: '取消',
		// 		type: 'warning'
		// 	})
		// 	.then(async () => {
		// 		this.$loading.show('处理中...');
		// 		let res = await this.$get(suplierApi.del,{supplierId:this.sdata.supplierId});
		// 		const {data,msg,status} = res;
		// 		if(status){
		// 			this.sdata.isDel = true;
		// 			this.listArr[this.sdata.index] = this.sdata;
		// 			this.$message.success(msg);
		// 		}else{
		// 			this.$message.error(msg);
		// 		}
		// 		this.$loading.hide();

		// 	})
		// 	.catch(() => {
		// 		/* this.$message({
		// 			type: 'info',
		// 			message: '已取消删除'
		// 		});  */
		// 	});
		// },
		//恢复删除
		// restore(){

		// },
    //提交
    // submitForm(){
    //   let vm = this;
    //   this.$refs['resourceFrom'].validate(async (vaild)=>{
    //     if(!vaild) return false;
    //     let postUrl = resource.add;
    //     if(this.isEdit) postUrl = resource.modify;
    //     //console.log(this.resourceFrom);return;
    //     this.isDisable = true;
    //     let res = await this.$post(postUrl,this.resourceFrom);
    //     if(res.status){
    //       this.$message.success(res.msg);
    //       this.resourceFrom = {
    //         resourceType:1,
    //         parentResourceId:0
    //       };
    //       this.dialogFormVisible = false;
    //       this.getListArr();
    //     }else{
    //       this.$message.error(res.errorMsg);
    //     }

    //   });

    // }

	}
}
</script>
